import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
const optionOne = ['Improvisando cada semana', 'Sin saber si está correcto', 'Alumnas que se van', 'Estrés y agotamiento', 'Inseguridad al cobrar'];
const optionTwo = ['240 ejercicios listos', 'Sistema claro y profesional', 'Alumnas que vuelven cada semana', '5 minutos de preparación', 'Confianza para cobrar más'];
export function FinalCTA() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-59" data-mp="33uw8h7yrqitb">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-60" data-mp="33w7jnsujmsug">
        <h2 className="font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-61" data-mp="38th8p7e0t2hr">
          🔥 La decisión es hoy
        </h2>
        <p className="mt-3 text-base text-ink/80 sm:text-lg" data-id="element-62" data-mp="1242peapknjgk">Tienes dos opciones:</p>

        <div className="mt-8 grid gap-4 text-left sm:grid-cols-2" data-id="element-63" data-mp="171b8cdijnriv">
          <div className="rounded-2xl border border-primary/10 bg-paper p-6" data-id="element-64" data-mp="q83od332wdjd">
            <p className="font-heading text-sm font-semibold uppercase tracking-wide text-ink/60" data-id="element-65" data-mp="l9k0uy8u6tow">
              Opción 1: Seguir como estás
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-66" data-mp="z0ffys9xi70x">
              {optionOne.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/80" data-id="element-67" data-mp="v0n3i4hezgqa">
                  <XIcon size={16} className="mt-0.5 flex-shrink-0 text-danger" data-id="element-68" data-mp="7aayp2hgu03x" />
                  <span data-id="element-69" data-mp="2bpyh327rgfh">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-accent/30 bg-white p-6 shadow-card-medium" data-id="element-70" data-mp="gbin8su6jmkt">
            <p className="font-heading text-sm font-semibold uppercase tracking-wide text-accent" data-id="element-71" data-mp="babf2so4kldm">
              Opción 2: Entrar con todo resuelto
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-72" data-mp="1mqruwn3ld410">
              {optionTwo.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink" data-id="element-73" data-mp="kd3qc6r1cgg8">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-74" data-mp="pc6p59gf9qfr" />
                  <span data-id="element-75" data-mp="pe19aljvdeis">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-sm font-semibold text-danger sm:text-base" data-id="element-76" data-mp="ycmm002ntzbn">
          El precio sube en 24 horas. Después de eso, nunca bajará.
        </p>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-6 flex flex-col items-center" data-id="element-77" data-mp="1ogory82i97e">
          <PrimaryButton href={CHECKOUT_URL} data-id="element-78" data-mp="fdqwv35nsb4o">Quiero la Enciclopedia Completa Ahora</PrimaryButton>
          <p className="mt-3 text-xs text-ink/60" data-id="element-79" data-mp="3e4aftmmdnbq8">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía 7 días
          </p>
          <p className="mt-1 text-xs text-ink/50" data-id="element-80" data-mp="3j1j3g2qao7yv">💱 El pago se procesará en la moneda de tu país</p>
        </m.div>
      </div>
    </section>;
}